// @flow

import { applyStylingHoc, type StyleOuterProps, type StyleProps } from '@fcse/tsbob/dist/lib/styling'
import React from 'react'
import { FormattedMessageSanitized } from '../../FormattedMessageSanitized'

import baseStyles from './PressBoilerplate.scss'

type Props = {
  ...StyleProps,
  content: Object,
  contentLinks?: Object
}

const PressBoilerplate = ({ styles, content, contentLinks }: Props) => (
  <div className={styles.root}>
    <FormattedMessageSanitized {...content} values={contentLinks} />
  </div>
)

export default applyStylingHoc(baseStyles)<$Diff<Props, StyleProps> & StyleOuterProps, Function>(PressBoilerplate)
